import { LoadingDotsIcon } from '@verbit-ai/icons-library'

import * as S from './styles'

export const SettingUpSessionTemplate = () => (
    <S.TemplateContent>
        <LoadingDotsIcon size={16} />
        <S.TemplateTitle>Connecting</S.TemplateTitle>
        <S.TemplateDescription>Setting up your session. You&rsquo;ll be able to record shortly.</S.TemplateDescription>
    </S.TemplateContent>
)
